module.exports = __webpack_public_path__ + "img/icon-induc.43c2244c.svg";